import React from "react";
import { getCorpus } from "containers/LanguageModelArtifact/reducer";
import { getCorpusList } from "containers/View/reducer";
import { useSelector, useDispatch } from "types/store";
import { customMapper, selectOnChangeWrapper } from "utils/select";
import styles from "./style.module.css";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import UploadDocument from "components/LanguageModelArtifact/UploadDocument";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
const DocumentSelector = ({ onChange, artifactId, allowUpload, className, style, selectorStyle, forceSelection, filter, sampleDataId, defaultAddData, ...retProps }) => {
    const dispatch = useDispatch();
    const selectedArtifact = useSelector((state) => getCorpus(state, artifactId ?? -1));
    const artifacts = useSelector((state) => getCorpusList(state)).filter((a) => {
        if (!filter || typeof filter !== "function") {
            return true;
        }
        return filter(a);
    });
    const mapper = customMapper((x) => {
        if (x === "CREATE_CORPUS") {
            return "Create New Document Set";
        }
        else if (x === "ALL_AVAILABLE") {
            return "All Available Document Sets";
        }
        else if (x?.id === sampleDataId) {
            return `${x.name} (Sample Document)`;
        }
        else {
            return `${x.name}`;
        }
    });
    const isUpload = useSelector((state) => chatGPTReducer.getIsUploadDocument(state));
    const rawOptions = artifacts.slice();
    if (!forceSelection) {
        rawOptions.unshift("ALL_AVAILABLE");
    }
    if (allowUpload) {
        rawOptions.unshift("CREATE_CORPUS");
    }
    const sampleArtifact = useSelector((state) => languageModelArtifactReducer.getCorpus(state, sampleDataId ?? -1));
    if (sampleDataId && sampleArtifact) {
        rawOptions.unshift(sampleArtifact);
    }
    const options = mapper.mapAll(rawOptions);
    const value = mapper.map(isUpload ? "CREATE_CORPUS" : !forceSelection && selectedArtifact === undefined ? "ALL_AVAILABLE" : selectedArtifact);
    const handleChange = (val) => {
        if (val === "CREATE_CORPUS") {
            if (allowUpload) {
                dispatch(chatGPTReducer.updateIsUploadDocument(true));
            }
        }
        else {
            if (val === "ALL_AVAILABLE") {
                val = undefined;
            }
            onChange(val);
            if (isUpload) {
                dispatch(chatGPTReducer.updateIsUploadDocument(false));
            }
        }
    };
    // useEffect(() => {
    //     if (selectedArtifact === undefined && allowUpload && defaultAddData) {
    //         handleChange("CREATE_CORPUS");
    //     }
    // }, []);
    return (React.createElement("div", { className: (allowUpload ? styles.documentSelectUpload : "") + " " + (className ? className : ""), style: style },
        React.createElement(DynamicWidthSelector, { options: options, value: value, onChange: selectOnChangeWrapper(handleChange), isSearchable: true, placeholder: `Select a Document Set...`, label: "Document Set", menuPlacement: "top", style: selectorStyle, ...retProps }),
        allowUpload && isUpload && (React.createElement("div", { className: styles.documentSelectUploadButton, id: "chat-upload-document" },
            React.createElement(UploadDocument, { isCreate: true, style: { fontSize: "16px" }, isSmall: false, onComplete: (artifact) => {
                    if (artifact?.id) {
                        onChange(artifact);
                        dispatch(chatGPTReducer.updateIsUploadDocument(false));
                    }
                } })))));
};
export default DocumentSelector;
